var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "share_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#share_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.062 5.492c-2.279-1.29-5.2-.49-6.53 1.768a4.65 4.65 0 0 0 1.704 6.433c2.09 1.183 4.718.61 6.167-1.234l12.381 6.224a4.66 4.66 0 0 0-.03 2.648l-12.296 6.182a4.653 4.653 0 0 0-1.396-1.206c-2.279-1.29-5.2-.491-6.53 1.767a4.65 4.65 0 0 0 1.704 6.434c2.279 1.29 5.2.49 6.53-1.768a4.677 4.677 0 0 0 .48-3.664l12.296-6.182c.368.477.836.89 1.396 1.207 2.279 1.29 5.2.49 6.53-1.768a4.65 4.65 0 0 0-1.704-6.434c-2.09-1.182-4.719-.609-6.167 1.235l-.005-.003-12.376-6.222a4.64 4.64 0 0 0-2.154-5.417Zm-5.01 2.633c.846-1.436 2.696-1.932 4.125-1.123a2.931 2.931 0 0 1 1.07 4.058c-.847 1.437-2.697 1.933-4.126 1.123a2.931 2.931 0 0 1-1.07-4.058Zm20.702 10.408c.846-1.437 2.695-1.933 4.125-1.124a2.931 2.931 0 0 1 1.069 4.058c-.846 1.437-2.696 1.933-4.125 1.124a2.931 2.931 0 0 1-1.07-4.058ZM7.052 28.94c.846-1.437 2.696-1.933 4.125-1.123a2.931 2.931 0 0 1 1.07 4.058C11.4 33.31 9.55 33.806 8.12 32.998a2.931 2.931 0 0 1-1.07-4.058Z",
  clipRule: "evenodd"
}))));
export default SvgShare;